import { PM_PROVIDERS } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import { WhiteSection } from 'components/base/layout-components';
import React from 'react';
import { getSensorAuthorization } from '../../services/project-management.service';
import PMConfiguration from '../../connected-components/PMConfiguration';
import ConnectView from './components/ConnectView';
import { SENSOR_STATES } from '@linearb/linjs-common';

const Clubhouse = ({
  selectedTeam,
  isOrgSettings,
  sensorAuthorizations,
  createSensorAuthorization,
  isTeamLicense,
  entityName
}) => {
  const selectedManagementTool = getSensorAuthorization({
    sensorAuthorizations,
    sensorId: PM_PROVIDERS.CLUBHOUSE
  });

  const isPmToolOk = selectedManagementTool?.state === SENSOR_STATES.ok;

  return (
    <WhiteSection t={SPACES['x-medium']}>
      {selectedManagementTool && isPmToolOk ? (
        <PMConfiguration
          selectedTeam={selectedTeam}
          isOrgSettings={isOrgSettings}
          selectedManagementTool={selectedManagementTool}
          entityName={entityName}
        />
      ) : (
        <ConnectView
          createSensorAuthorization={createSensorAuthorization}
          isTeamLicense={isTeamLicense}
        />
      )}
    </WhiteSection>
  );
};

export default Clubhouse;
